import { put } from 'redux-saga/effects'
import { IPcr } from '../../pcr/store/pcr.types'
import { setSignerList } from '../store/completeChart.actions'
export function* getSignerData(pcrDoc: IPcr) {
  const { signerDetails } = pcrDoc
  if (signerDetails && Object.keys(signerDetails).length !== 0) {
    yield put(setSignerList(signerDetails))
  }
}
